import { type FC } from 'react'
import { styled } from '@mui/material'

export const ListItemLabel: FC = styled('label')(() => ({
  position: 'relative',
}))
